import React, {useEffect, useRef, useState, useMemo} from 'react';
import QRCode from 'qrcode';

export default function QrCodeCanvas({text}) {
    const canvasRef = useRef();
    const [isGenerating, setIsGenerating] = useState(false);
    const [hasError, setHasError] = useState(false);

    const opts = useMemo(() => ({
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 0.92,
        margin: 2,
        width: 400,
        color: {
            dark: '#1f2937',
            light: '#ffffff'
        }
    }), []);

    useEffect(() => {
        if (!text || text.trim() === '') {
            setHasError(false);
            setIsGenerating(false);
            return;
        }

        setIsGenerating(true);
        setHasError(false);

        const canvas = canvasRef.current;
        if (canvas) {
            QRCode.toCanvas(canvas, text, opts, (error) => {
                setIsGenerating(false);
                if (error) {
                    setHasError(true);
                    console.error('Erro ao gerar QR Code:', error);
                }
            });
        }
    }, [text, opts]);

    const handleDownload = () => {
        if (!canvasRef.current || !text || text.trim() === '') return;

        const canvas = canvasRef.current;
        const url = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.download = `qrcode-${Date.now()}.png`;
        link.href = url;
        link.click();
    };

    if (!text || text.trim() === '') {
        return (
            <div className="qr-placeholder">
                <div className="placeholder-content">
                    <div className="placeholder-icon">📱</div>
                    <p className="placeholder-text">Seu QR Code aparecerá aqui</p>
                    <p className="placeholder-hint">Digite uma URL ou texto acima para começar</p>
                </div>
            </div>
        );
    }

    if (hasError) {
        return (
            <div className="qr-error">
                <div className="error-content">
                    <div className="error-icon">⚠️</div>
                    <p className="error-text">Erro ao gerar QR Code</p>
                    <p className="error-hint">Verifique se o texto é válido</p>
                </div>
            </div>
        );
    }

    return (
        <div className="qr-container">
            <div className="qr-wrapper">
                {isGenerating && (
                    <div className="qr-loading">
                        <div className="spinner"></div>
                        <p>Gerando QR Code...</p>
                    </div>
                )}
                <canvas 
                    ref={canvasRef} 
                    id="canvas"
                    className={`qr-canvas ${isGenerating ? 'generating' : ''}`}
                />
            </div>
            <button 
                onClick={handleDownload}
                className="download-btn"
                disabled={isGenerating}
            >
                <span className="download-icon">⬇️</span>
                <span>Baixar QR Code</span>
            </button>
        </div>
    );
}
